import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
import MenuIcons from '../../../app/helpers/menu-icons';
import PermissionService from '../../../services/permission.service';
import templateMarkup from 'raw-loader!./historical2-app-view.html';
import LoginService from "../../../services/login.service";
import DataProvider from "../../../app/data-framework/data-provider";

function HistoricalAppView(params) {
    var self = this;

    self.dataProvider = DataProvider.getInstance();
    self.permissionService = new PermissionService(LoginService.userObject);
    self.app = self.dataProvider.getModuleDictionary().advancedAnalytics;
    self.route = params.route;
    self.view = ko.pureComputed(function() { return self.route().view; });

    self.tabId = ko.pureComputed(function() {
      return self.route().tabId ? self.route().tabId.toString() : '0';
    });

    if ((self.route().level === "app") && (self.route().view === 'historical2-dashboard-view')) {
        window.location.hash = '#historical2/dashboard';
        return;
    }

    var supportedWidth = 480;
    self.resolutionNotSupported = ($(window).width() < supportedWidth);
    self.appsMenu = ko.observableArray(self.dataProvider.getListOfApps());

    var dashboardViews = [
        { id: 'myDashboard', url: '#historical2/dashboard', name: 'My Dashboard', viewId: 'historical2dashboard', badge: undefined },
        { id: 'adoption', url: '#historical2/adoption', name: 'Adoption', viewId: 'historical2adoption', badge: undefined },
        { id: 'issues', url: '#historical2/issues', name: 'Issues', viewId: 'historical2issues', badge: undefined },
        { id: 'capacity', url: '#historical2/capacity', name: 'Capacity', viewId: 'historical2capacity', badge: undefined },
    ];
    var datasetViews = [
        { id: 'meetings', url: '#historical2/meetings', name: 'Meetings', badge: undefined},
        { id: 'endpoints', url: '#historical2/endpoints', name: 'Endpoints', badge: undefined},
        { id: 'infrastructure', url: '#historical2/infrastructure', name: 'Infrastructure', badge: undefined},
        { id: 'users', url: '#historical2/user', name: 'Users', badge: undefined},
    ];

    var newDatasetViews = [
        { id: 'meetings', url: '#historical2/dataset/meetings', name: 'Meetings', badge: undefined},
        // { id: 'vmrs', url: '#historical2/dataset/vmrs', name: 'VMRs', badge: undefined},
        { id: 'participants', url: '#historical2/dataset/participants', name: 'Participants', badge: undefined},
        { id: 'managedEndpoints', url: '#historical2/dataset/managedEndpoints', name: 'Managed Endpoints', badge: undefined},
        { id: 'unmanagedEndpoints', url: '#historical2/dataset/unManagedEndpoints', name: 'Unmanaged Endpoints', badge: undefined},
        // { id: 'inventory', url: '#historical2/dataset/inventory', name: 'Inventory', badge: undefined},
        { id: 'calls', url: '#historical2/dataset/calls', name: 'Calls', badge: undefined},
        { id: 'infrastructure', url: '#historical2/dataset/infrastructure', name: 'Infrastructure', badge: undefined},
        { id: 'trunks', url: '#historical2/dataset/trunks', name: 'Trunks', badge: undefined},
        { id: 'users', url: '#historical2/dataset/users', name: 'Users', badge: undefined},
    ];

    if (DataProvider.getInstance().isInternalUser() || LoginService.userObject.featureFlags.NetworksDatasetOptIn || LoginService.userObject.featureFlags.LabsOptIn) {
        datasetViews.push({ id: 'networks', url: '#historical2/networks', name: 'Networks', badge: undefined});
        newDatasetViews.push({ id: 'networks', url: '#historical2/dataset/networks', name: 'Networks', badge: undefined});
    }

    let labs = [
        { id: 'networkInsights', url: '#historical2/labs/networkInsights', name: 'Network Insights'},
    ];

    //add rooms if enabled, or rooms advertising if not enabled
    if(self.dataProvider.isRoomInsightsInModules()) {
        datasetViews.push({ id: 'workspaces', url: '#historical2/rooms', name: 'Workspaces', badge: undefined });
        newDatasetViews.push({ id: 'workspaces', url: '#historical2/dataset/workspaces', name: 'Workspaces', badge: undefined });
        dashboardViews.push({ id: 'workspaces', url: '#historical2/roomboard', name: 'Workspaces', viewId: 'historical2roomboard', badge: undefined });
    }

    var subModules = [
        { id: 'historical2Dashboards', name: "Dashboards", icon: MenuIcons.getDashboard(), url: undefined, badge: undefined, views: dashboardViews},
    ];

    if (self.permissionService.hasPermission(self.permissionService.ViewDatasetsPermission) &&  (DataProvider.getInstance().isInternalUser() || LoginService.userObject.featureFlags.NewDatasetOptIn)) {
        subModules.push({ id: 'historical2NewDatasets', name: "Datasets", icon: MenuIcons.getDatasets(), url: undefined, badge: 'alpha', views: newDatasetViews});
    }

    if (self.permissionService.hasPermission(self.permissionService.ViewDatasetsPermission)) {
        subModules.push({ id: 'historical2Datasets', name: "Datasets", icon: MenuIcons.getDatasets(), url: undefined, badge: undefined, views: datasetViews});
    }


    if (self.permissionService.hasPermission(self.permissionService.ViewDatasetsPermission) &&  (DataProvider.getInstance().isInternalUser() || LoginService.userObject.featureFlags.LabsOptIn)) {
        subModules.push({ id: 'historical2labs', name: "Labs", icon: MenuIcons.getLabs(), url: undefined, views: labs, badge: 'beta'});
    }


    if (self.permissionService.hasPermission(self.permissionService.ReportsPermission)) { //UI-1218
        subModules.push({ id: 'historical2Reports', name: "Reports", icon: MenuIcons.getReports(), url: '#historical2/reports', badge: undefined, views: []});
    }

    if (self.permissionService.hasPermission(self.permissionService.SettingsViewPermission)) {
        subModules.push({ id: 'historical2Settings', name: 'Settings', icon: MenuIcons.getSettings(), url: '#historical2/settings', badge: undefined, views: []});
    }

    // this is only needed for testing out the new query engine in side-by-side mode, can be removed once testing is complete
    if (window.sessionStorage.getItem("feature.qe") !== null) {
        subModules.push({ id: 'qe', name: 'QE: ' + window.sessionStorage.getItem("feature.qe"), icon: 'fa fa-server', url: null, badge: 'beta', views: []});
    }

    self.sideMenu = ko.observableArray(subModules);
}

export default { viewModel: HistoricalAppView, template: templateMarkup };
